import React from 'react';
import styles from './style.local.scss';
import FacebookShareWidget from "../FacebookShareWidget/FacebookShareWidget.jsx";
import TwitterShareWidget from "../TwitterShareWidget/TwitterShareWidget.jsx";
import ShareWidget from "../ShareWidget/ShareWidget.jsx";
import _ from 'lodash';

const URL = "http://projects.asiaweekly.com/shippings-dirty-secrets";
const TW_DESCRIPTION = "Shipping pollution kills tens of thousands per year in Asia. Find out Shipping's Dirty Secrets.";
const FB_DESCRIPTION = "Cargo passing through Asian ports has more than tripled since 2000. Is Asia, or the world, doing enough to tackle the environmental fallout?";
const TITLE = "Shipping's Dirty Secrets";
const HASHTAGS= "AWRedLetter";

const TRIGGERPOINT = 60;
export default class AppBar extends React.Component {
  constructor(props,context) {
    super(props,context);
    this.handleScroll = this.handleScroll.bind(this);
    this._handleScroll = _.throttle(this.handleScroll,300);
    this.state = {
      collapsed: false
    }
  }
  componentDidMount() {
    if(window) {
      window.addEventListener("scroll",this._handleScroll);
      this.handleScroll();
    }
  }
  handleScroll() {
    let shouldBeCollapsed = window.pageYOffset > TRIGGERPOINT;
    if(shouldBeCollapsed !== this.state.collapsed) {
      this.setState({collapsed: shouldBeCollapsed});
    }  
  }
  render() {
    return(
      <div className="fixed-nav">
        <nav role="navigation" className={this.state.collapsed?styles.dark:styles.transparent}>
          <div className="nav-wrapper nav-container">
            <a id="logo-container" href="#" className={"brand-logo "+(this.state.collapsed?styles["logo-smallfont"]:styles["logo-bigfont"])}>
              <span className={this.state.collapsed?styles["highlight-letter"]:styles["highlight-letter-background"]}>A</span>sia Weekly
            </a>
            <div className="right hide-on-large-only" style={{position:"relative",top:"50%",transform:"translateY(-50%)"}}>
              <ShareWidget highlightMode={this.state.collapsed?"inner":"outer"}>
                <FacebookShareWidget title={TITLE} description={FB_DESCRIPTION} url={URL} highlightMode="outer" uniqueId="99" />
                <TwitterShareWidget hashtags={HASHTAGS} description={TW_DESCRIPTION} url={URL} highlightMode="outer" uniqueId="99" />
              </ShareWidget>
            </div>
            <div className="right hide-on-med-and-down" style={{position:"relative",top:"50%",transform:"translateY(-50%)"}}>
              <TwitterShareWidget hashtags={HASHTAGS} description={TW_DESCRIPTION} url={URL} highlightMode={this.state.collapsed?"inner":"outer"}/>
              <FacebookShareWidget title={TITLE} description={FB_DESCRIPTION} url={URL} highlightMode={this.state.collapsed?"inner":"outer"}/>
            </div>
      
            
          </div>
        </nav>
      </div>
    )
  }
}
/*AppBar.contextTypes = {
    scrollPos: React.PropTypes.number.isRequired
};*/

/*
<ul id="nav-mobile" className="side-nav">
              <li><a href="#">Navbar Link</a></li>
            </ul>
            <a href="#" data-activates="nav-mobile" className="button-collapse"><i className="material-icons">menu</i></a>
     */


// WEBPACK FOOTER //
// ./src/js/components/AppBar/AppBar.jsx